import { combineReducers } from "redux";
import container from "./components/containers/reducer";
import permissionReducer from "./components/modules/SystemSetting/PermissionGroup/permission.reducer";
import usersReducer from "./components/modules/UserManagement/usersManagement.reducer";
import authentication from "./components/modules/auth/auth.reducer";
import banksReducer from "./components/modules/BankManagement/banksManagement.reducer";
import levelsReducer from "./components/modules/LevelManagement/levelManagement.reducer";
import ordersReducer from "./components/modules/OrderManagement/orderManagement.reducer";
import productsReducer from "./components/modules/ProductManagement/productManagement.reducer";
import injectionsReducer from "./components/modules/InjectionManagement/injectionManagement.reducer";
import transactionReducer from "./components/modules/TransactionManagement/transactionManagement.reducer";
import settingsReducer from "./components/modules/SettingsManagement/settingsManagement.reducer";

const rootReducer = combineReducers({
  container,
  authentication,
  usersReducer,
  permissionReducer,
  banksReducer,
  levelsReducer,
  ordersReducer,
  productsReducer,
  injectionsReducer,
  transactionReducer,
  settingsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
